<template>
  <footer class="footer">
    <div class='container'>
      <div class="footer__wrapper">
        <div class="footer__up">
          <div class="faq">
            <router-link to="/how-it-works">О нас</router-link>
            <a href="#" class="footer__nav-link">Как разобраться во всем самому?</a>
          </div>
          <nav class="footer__nav">
            <ul class="footer__nav-list">
              <li v-for="group in groups" :key="group.id"><router-link :to="'/groups/' + group.id" class="footer__nav-link">{{group.name}}</router-link></li>
            </ul>
          </nav>
          <div class="footer__info">
            <div class="cards__image">
              <img src="/static/img/footer/visa.svg" alt="Карта Visa" />
              <img src="/static/img/footer/mastercard.svg" alt="Карта mastercard" />
              <img src="/static/img/footer/mir.svg" alt="Карта mir" />
            </div>
            <div class="footer__contacts">
              <a class="footer__phone" href="tel:88002010339">8 800 201 0339</a>
              <a class="footer__email" href="mailto:a@avtourist.com">a@avtourist.com</a>
            </div>
          </div>
        </div>
        <div class="footer__company">
          <div class="company-name">НО АНО Первое Арбитражное Учреждение</div>
          <div class="company-second-info">ИНН 6163149544 <span>ОГРН 1166100052128</span></div>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
import axios from '@/router/http'
export default {
  name: 'footer',
  data () {
    return {
      groups: []
    }
  },
  mounted () {
    axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=31').then(response => {
      this.groups = response.data
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/include/footer.vue